export default "__VITE_ASSET__8709c91d__"